import React, { useState } from 'react';
import './MarginControl.css';

function MarginControl({ margins = {}, onChange }) {
  const [isLinked, setIsLinked] = useState(true);

  // Valeurs par défaut
  const marginTop = margins.marginTop || '0px';
  const marginRight = margins.marginRight || '0px';
  const marginBottom = margins.marginBottom || '0px';
  const marginLeft = margins.marginLeft || '0px';

  const handleChange = (side, value) => {
    if (isLinked) {
      // Si lié, mettre à jour toutes les marges
      onChange({
        marginTop: value,
        marginRight: value,
        marginBottom: value,
        marginLeft: value
      });
    } else {
      // Sinon, mettre à jour seulement le côté spécifique
      onChange({
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        [side]: value
      });
    }
  };

  // Fonction pour incrémenter/décrémenter avec les flèches du clavier
  const handleKeyDown = (e, side, currentValue) => {
    if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') {
      return;
    }

    e.preventDefault();

    // Parser la valeur actuelle pour extraire le nombre et l'unité
    const match = currentValue.match(/^(-?\d*\.?\d+)(.*)$/);

    if (!match) {
      // Si pas de match, considérer comme 0px
      const newValue = e.key === 'ArrowUp' ? '1px' : '-1px';
      handleChange(side, newValue);
      return;
    }

    const numValue = parseFloat(match[1]) || 0;
    const unit = match[2] || 'px';

    // Déterminer l'incrément selon les touches modificatrices
    let increment = 1;
    if (e.shiftKey) {
      increment = 10;
    } else if (e.altKey) {
      increment = 0.1;
    }

    // Calculer la nouvelle valeur
    const delta = e.key === 'ArrowUp' ? increment : -increment;
    let newValue = numValue + delta;

    // Arrondir à 1 décimale si on utilise Alt
    if (e.altKey) {
      newValue = Math.round(newValue * 10) / 10;
    }

    // Construire la nouvelle chaîne
    const newValueStr = `${newValue}${unit}`;
    handleChange(side, newValueStr);
  };

  return (
    <div className="margin-control">
      <div className="margin-control-header">
        <label>Marges</label>
        <button
          type="button"
          className={`link-button ${isLinked ? 'linked' : ''}`}
          onClick={() => setIsLinked(!isLinked)}
          title={isLinked ? 'Déverrouiller les marges' : 'Verrouiller les marges'}
        >
          {isLinked ? '🔒' : '🔓'}
        </button>
      </div>

      <div className="margin-grid">
        <div className="margin-input-group">
          <label className="margin-label">↑</label>
          <input
            type="text"
            className="margin-input"
            value={marginTop}
            onChange={(e) => handleChange('marginTop', e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, 'marginTop', marginTop)}
            placeholder="0px"
          />
        </div>

        <div className="margin-input-group">
          <label className="margin-label">→</label>
          <input
            type="text"
            className="margin-input"
            value={marginRight}
            onChange={(e) => handleChange('marginRight', e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, 'marginRight', marginRight)}
            placeholder="0px"
          />
        </div>

        <div className="margin-input-group">
          <label className="margin-label">↓</label>
          <input
            type="text"
            className="margin-input"
            value={marginBottom}
            onChange={(e) => handleChange('marginBottom', e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, 'marginBottom', marginBottom)}
            placeholder="0px"
          />
        </div>

        <div className="margin-input-group">
          <label className="margin-label">←</label>
          <input
            type="text"
            className="margin-input"
            value={marginLeft}
            onChange={(e) => handleChange('marginLeft', e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, 'marginLeft', marginLeft)}
            placeholder="0px"
          />
        </div>
      </div>
    </div>
  );
}

export default MarginControl;